<template>
  <div>
    <!-- 사인 -->
    <table v-if="isPrint">
      <tbody>
        <tr>
          <td rowspan="2" class="title">종사자 안전·보건 점검표</td>
          <td rowspan="2" class="titleCell bordered" style="width: 33px">결<br /><br /><br />재</td>
          <td class="titleCell signTitle bordered">담당자</td>
        </tr>
        <tr>
          <td class="signBody bordered">
            <div style="width: 125px; height: 80px">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    목록-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-10 mb-12">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div v-for="(inspection, indexRows) in form.inspectList" v-bind:key="inspection.id">
      <table-inspect
        style="break-inside: auto !important;"
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :is-not-dot-in-label="true"
        :title="inspection.title"
        tableHeaderTitle="점검항목"
        :list="inspection.list"
        @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
        @update-note="
          (param1, param2) => {
            updateListNote(indexRows, param1, param2);
          }
        "
        v-if="inspection.check"
      />
    </div>

    <!-- 기타 의견 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기타 의견</h5>
      <div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputA_1 }}</p>
        <ml-textarea :readonly="board.readonly" v-else v-model="form.inputA_1" class="w-full" rows="5" />
      </div>
    </div>

    <!-- 확인자 -->
    <div v-if="!isPrint" class="mt-28px">
      <div>
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>담당자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspect";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        inspectList: [
          {
            id: 1,
            title: "급식종사자",
            label: "급식종사자",
            check: false,
            list: [
              {
                id: 1,
                label: "1. 바닥의 물·기름·물때 등으로 인해 미끄러질 위험 여부",
                is_checked: "",
              },
              {
                id: 2,
                label: "2. 통로 확보 및 통행로나 바닥에 호스, 물품 적재·방치 여부 ",
                is_checked: "",
              },
              {
                id: 3,
                label: "3. 장애물(문턱·배관·패인곳 및 돌출부 등)로 인해 넘어질 위험 여부",
                is_checked: "",
              },
              {
                id: 4,
                label: "4. 조리장·계단·통로에 적정한 조명 설치 여부 ",
                is_checked: "",
              },
              {
                id: 5,
                label: "5. 계단에 난간 설치, 답단 끝에 미끄러짐 방지 조치 여부",
                is_checked: "",
              },
              {
                id: 6,
                label: "6. 미끄러짐 방지 장화 등 보호구 착용 여부",
                is_checked: "",
              },
              {
                id: 7,
                label: "7. 청소 후 트렌치 덮개를 원상태로 덮어 놓았는지 여부",
                is_checked: "",
              },
              {
                id: 8,
                label: "8. 왁스, 물청소 등으로 넘어짐 위험장소에 “미끄러짐표지” 부착 여부",
                is_checked: "",
              },
              {
                id: 9,
                label: "9. 문은 쉽게 열고 닫을 수 있는 구조를 유지하고 있는지 여부",
                is_checked: "",
              },
              {
                id: 10,
                label: "10. 재료 운반대차 및 배식차에 끼일 위험 여부 ",
                is_checked: "",
              },
              {
                id: 11,
                label: "11. 양념재료(마늘·파·양파 등) 분쇄기·절단기에 말려들 위험 여부 ",
                is_checked: "",
              },
              {
                id: 12,
                label: "12. 기계의 회전체(벨트·체인·회전날개 등)에 방호덮개 설치 여부",
                is_checked: "",
              },
              {
                id: 13,
                label: "13. 리프트, 덤웨이터의 안전한 사용 여부 \n- 사람 탑승금지 조치, (출입)문이 열린 상태에서는 동작이 안 되도록 조치되어 있는지 여부\n - 사용중량, 경고표지 부착 여부 등 ",
                is_checked: "",
              },
              {
                id: 14,
                label: "14. 절단기·분쇄기 칼날 부위에 베임방지용 덮개 설치 여부",
                is_checked: "",
              },
              {
                id: 15,
                label: "15. 칼날 등에 베일 위험을 방지하기 위한 조치 여부",
                is_checked: "",
              },
              {
                id: 16,
                label: "16. 칼 용도 외 사용 여부 (김치포장 끈 제거, 캔 뚜껑 제거, 식용류 뚜껑 제거 등)",
                is_checked: "",
              },
              {
                id: 17,
                label: "17. 식자재 운반카트의 바퀴 고정장치(stopper) 정상작동 여부",
                is_checked: "",
              },
              {
                id: 18,
                label:
                  "18. 부딪힘 사고 유형별 예방 확인\n- 선반 등 돌출부 부딪힘\n- 이동 중인 급식카트와 부딪힘\n- 이동 중 시야 미확보 부딪힘\n- 식기세척, 청소 후 일어서다가 물체와 부딪힘\n- 의자, 작업발판 등 위에서 내려오다가 미끄러져 부딪힘",
                is_checked: "",
              },
              {
                id: 19,
                label: "19. 전기 기계·기구에 감전 예방용 접지 상태 여부",
                is_checked: "",
              },
              {
                id: 20,
                label: "20. 누전차단기 설치 및 월1회 이상 동작 점검 여부",
                is_checked: "",
              },
              {
                id: 21,
                label: "21. 전선의 노후화 또는 피복손상, 심하게 구부러짐 여부",
                is_checked: "",
              },
              {
                id: 22,
                label: "22. 가스누출감지기, 경보기가 정상적으로 작동하는지 여부",
                is_checked: "",
              },
              {
                id: 23,
                label: "23. 가스공급배관에서 가스가 누출되고 있지 않은지 여부",
                is_checked: "",
              },
              {
                id: 24,
                label: "24. 급식실 작업장 환기는 충분히 실시하고 있는지 여부",
                is_checked: "",
              },
              {
                id: 25,
                label: "25. 환기 방법",
                is_checked: "",
              },
              {
                id: 26,
                label: "26. 환기장치 설치 및 조리 시 사용여부",
                is_checked: "",
              },
              {
                id: 27,
                label: "27. 환기장치 작동 여부",
                is_checked: "",
              },
              {
                id: 28,
                label: "28. 급식실 후드청소 주기",
                is_checked: "",
              },
              {
                id: 29,
                label: "29. 급식실 위치",
                is_checked: "",
              },
              {
                id: 30,
                label: "30. 급식실에 적합한 소화기 비치 및 정상작동 여부",
                is_checked: "",
              },
              {
                id: 31,
                label: "31. 국솥 등에 한꺼번에 많은 양의 식자재를 넣고 있지 않은가",
                is_checked: "",
              },
              {
                id: 32,
                label: "32. 뜨거운 물, 국 등이 들어있는 회전식 국솥 핸들고정 장치가 정상적으로 고정되어 있는지 여부",
                is_checked: "",
              },
              {
                id: 33,
                label: "33. 자외선 살균기, 전격살충기 등 램프 적정선정 및 정상작동 여부",
                is_checked: "",
              },
              {
                id: 34,
                label: "34. 기타 각종 위험요인으로부터 근로자 보호조치 여부",
                is_checked: "",
              },
              {
                id: 35,
                label: "35. 고온 스팀 사용장소에 “고온 경고” 또는 “화상주의” 표지 게시 여부",
                is_checked: "",
              },
              {
                id: 36,
                label: "36. 뜨거운 용기 취급시 방열장갑 또는 보조집게 사용여부",
                is_checked: "",
              },
              {
                id: 37,
                label: "37. 조리실 등 고온다습하고 환기가 불충분한 장소에 적정한 환기, 통풍, 냉방시설 설치 및 관리여부",
                is_checked: "",
              },
              {
                id: 38,
                label: "38. 물질안전보건자료(MSDS)의 게시(비치) 및 교육 여부",
                is_checked: "",
              },
              {
                id: 39,
                label: "39. 취급용기 및 포장에 MSDS 경고표지 부착 여부",
                is_checked: "",
              },
              {
                id: 40,
                label: "40. 세제, 청소제 등 화학물질 취급시 고무장갑 등 적정 보호장구 착용여부",
                is_checked: "",
              },
              {
                id: 41,
                label: "41. 근골격계부담작업 유해요인조사 실시여부",
                is_checked: "",
              },
              {
                id: 42,
                label: "42. 근골격계질환 예방을 위해 인력작업 보조설비 및 편의설비 등 작업환경 개선여부",
                is_checked: "",
              },
              {
                id: 43,
                label: "43. 근골격계부담작업 종사자에 대한 유해성 주지 (교육 등) 적정성",
                is_checked: "",
              },
              {
                id: 44,
                label: "44. 중량물 안내포스터 부착 유무 - 5kg 이상 물체를 중량물로 취급",
                is_checked: "",
              },
              {
                id: 45,
                label: "45. 작업 전·후 스트레칭 실시 및 적정 휴식시간 배분 여부",
                is_checked: "",
              },
              {
                id: 46,
                label: "46. 운반작업 시 적정한 양 운반, 2인 1조작업 또는 이동대차 등 운반보조도구 사용여부",
                is_checked: "",
              },
            ],
          },
          {
            id: 2,
            title: "당직업무",
            label: "당직업무",
            check: false,
            list: [
              {
                id: 1,
                label: "1. 랜턴, 야광조끼, 야광봉, 안전화 등 챙겼는가?",
                is_checked: "",
              },
              {
                id: 2,
                label: "2. 계단을 오르내릴땐 손잡이를 잡는가?",
                is_checked: "",
              },
              {
                id: 3,
                label: "3. 주머니에 손을 넣고 경사, 결빙, 어두운 곳을 순찰하지 않는가?",
                is_checked: "",
              },
              {
                id: 4,
                label: "4. 흡연하면서 작업하거나 근무 중 음주하지 않는가?",
                is_checked: "",
              },
              {
                id: 5,
                label: "5. 통로는 충분히 밝은가?",
                is_checked: "",
              },
              {
                id: 6,
                label: "6. 통로는 정리정돈 되어 걸려 넘어질 위험이 없는가?",
                is_checked: "",
              },
              {
                id: 7,
                label: "7. 계단은 파손부위가 없고 미끄럼방지 조치를 하였는가?",
                is_checked: "",
              },
              {
                id: 8,
                label: "8. 경비책임자가 주기적으로 현장을 점검하는가?",
                is_checked: "",
              },
              {
                id: 9,
                label: "9. 현장 점검결과 문제점은 빠른 시일 내에 해결하는가?",
                is_checked: "",
              },
              {
                id: 10,
                label: "10. 비상연락망이 게시되어 있는가?",
                is_checked: "",
              },
              {
                id: 11,
                label: "11. 소화기 및 소화전의 작동 및 사용방법을 아는가?",
                is_checked: "",
              },
              {
                id: 12,
                label: "12. 화재발생 시 소방 및 대피방법을 알고 있는가?",
                is_checked: "",
              },
              {
                id: 13,
                label: "13. 무거운 물체 운반 시 2인 1조로 작업을 실시하는가?",
                is_checked: "",
              },
              {
                id: 14,
                label: "14. 올바른 중량물 취급방법에 대해 알고 있는가?",
                is_checked: "",
              },
              {
                id: 15,
                label: "15. 작업 전, 중, 후 주기적으로 스트레칭을 하는가?",
                is_checked: "",
              },
            ],
          },
          {
            id: 3,
            title: "통학보조",
            label: "통학보조",
            check: false,
            list: [
              {
                id: 1,
                label: "1. 운전원은 차량이 항상 청결하도록 유지하였는가?",
                is_checked: "",
              },
              {
                id: 2,
                label: "2. 운전 중 흡연 및 식음, 통화 등은 하지 않았는가?",
                is_checked: "",
              },
              {
                id: 3,
                label: "3. 운전 중 직무수행에 필요한 사람 이외의 탑승은 없었는가?",
                is_checked: "",
              },
              {
                id: 4,
                label: "4. 배차되지 않은 차량의 사적인 운행 행위는 금지되었는가?",
                is_checked: "",
              },
              {
                id: 5,
                label: "5. 운전원은 차량 밖으로 이동시 잠금장치를 하였는가?",
                is_checked: "",
              },
              {
                id: 6,
                label: "6. 운전원은 경제속도운행 및 안전운행에 노력하였는가?",
                is_checked: "",
              },
              {
                id: 7,
                label: "7. 승차 시 학생들의 안전한 탑승이 확인 된 후에 출발하였는가?",
                is_checked: "",
              },
              {
                id: 8,
                label: "8. 하차 시 학생들의 안전한 상태를 확인 후 하차하였는가?",
                is_checked: "",
              },
              {
                id: 9,
                label: "9. 승하차 시 지정된 장소에 대기하고 있던 학부모와 인사를 나누고 학생들을 안전하게 인도하였는가?",
                is_checked: "",
              },
              {
                id: 10,
                label: "10. 운행 중 창밖으로 손을 내밀거나 하는 위험 행동을 통제했는가?",
                is_checked: "",
              },
              {
                id: 11,
                label: "11. 출발 전 학생들의 안전밸트 착용 등의 상태를 확인하였는가?",
                is_checked: "",
              },
              {
                id: 12,
                label: "12. 차량의 학교 도착 후 유실물과 차량의 상태는 확인하였는가?",
                is_checked: "",
              },
            ],
          },
          {
            id: 4,
            title: "시설관리",
            label: "시설관리",
            check: false,
            list: [
              {
                id: 1,
                label: "1. 위험작업 시 안전모, 안전화 등 개인보호구를 착용하였는가?",
                is_checked: "",
              },
              {
                id: 2,
                label: "2. 사다리 작업 시 안전한 작업방법을 숙지하고 있는가?",
                is_checked: "",
              },
              {
                id: 3,
                label: "3. 각종 계기류 확인 시 감전 예방을 위한 절연장갑을 착용하였는가?",
                is_checked: "",
              },
              {
                id: 4,
                label: "4. 기계 점검, 보수 시 동력원을 완전히 차단 후 작업하는가?",
                is_checked: "",
              },
              {
                id: 5,
                label: "5. 고장난 승강기를 임의로 열거나 기기를 조작하지는 않는가?",
                is_checked: "",
              },
              {
                id: 6,
                label: "6. 승강기 점검, 보수 시 접근금지 표지판을 부착하는가?",
                is_checked: "",
              },
              {
                id: 7,
                label: "7. 각종 전기기구 작업 시 작업자가 감전사고에 대한 작업방법을 확실하게 인지하고 있는가? ",
                is_checked: "",
              },
              {
                id: 8,
                label: "8. 화학물질 취급 및 저장 시 별도의 지정된 장소에 보관하는가? ",
                is_checked: "",
              },
              {
                id: 9,
                label: "9. 사용하는 화학물질의 위험성 또는 유해성에 대해 정확히 알고 있는가?",
                is_checked: "",
              },
              {
                id: 10,
                label: "10. 소화기 및 소화전의 작동 및 사용방법을 아는가?",
                is_checked: "",
              },
              {
                id: 11,
                label: "11. 무거운 물체 운반 시 2인 1조로 작업을 실시하는가?",
                is_checked: "",
              },
              {
                id: 12,
                label: "12. 올바른 중량물 취급방법에 대해 알고 있는가?",
                is_checked: "",
              },
              {
                id: 13,
                label: "13. 작업 전, 중, 후 주기적으로 스트레칭을 하였는가?",
                is_checked: "",
              },
            ],
          },
          {
            id: 5,
            title: "미화원",
            label: "미화원",
            check: false,
            list: [
              {
                id: 1,
                label: "1. 바닥에 작업자가 걸려 넘어질 위험이 있는 장애물은 제거하였는가?",
                is_checked: "",
              },
              {
                id: 2,
                label: "2. 근로자의 통행에 장해가 없도록 채광 또는 조명시설이 충분한가?",
                is_checked: "",
              },
              {
                id: 3,
                label: "3. 교차점이나 코너에는 충돌방지용 거울을 설치하였는가?",
                is_checked: "",
              },
              {
                id: 4,
                label: "4. 다른 사람과 충돌을 방지하기 위해 우측통행을 하는가? ",
                is_checked: "",
              },
              {
                id: 5,
                label: "5. 화장실 타일이 깨지거나 비어있는 부분은 없는가?",
                is_checked: "",
              },
              {
                id: 6,
                label: "6. 청소 전 화장실 내부에 사람이 있는 지 확인하였는가?",
                is_checked: "",
              },
              {
                id: 7,
                label: "7. 화장실 천정이나 높은 벽 청소 시 사용하는 사다리에 미끄럼방지 조치를 하였는가? ",
                is_checked: "",
              },
              {
                id: 8,
                label: "8. 화장실 세면대나 변기 위에 올라가서 작업을 하지 않는가?",
                is_checked: "",
              },
              {
                id: 9,
                label: "9. 청소 중에는 “청소 중”을 알리는 표지를 하고 작업하는가?",
                is_checked: "",
              },
              {
                id: 10,
                label: "10. 청소 후 바닥에 미끄러운 세제나 물기를 깨끗이 제거하는가?",
                is_checked: "",
              },
              {
                id: 11,
                label: "11. 청소도구를 지정된 위치에 보관하는가?",
                is_checked: "",
              },
              {
                id: 12,
                label: "12. 자극성 세제를 이용한 청소 시 고무장갑을 착용하는가?",
                is_checked: "",
              },
              {
                id: 13,
                label: "13. 청소 중에는 미끄럼 방지용 장화를 착용하는가?",
                is_checked: "",
              },
            ],
          },
        ],

        inputA_1: "",
        sign1: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
    updateListCheck(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text;
    },
    updateListNote(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].note = text;
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  td {
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  .title {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    color: #2c2c2c;
    border: none;
    border-right: 1px solid #cdcdcd;
  }
  .signTitle {
    width: 125px;
    height: 38px;
  }
  .signBody {
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.titleCell {
  border-top: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
}
</style>
